import { useMemo, type JSX } from "react";

interface HighlightedTextProps {
  readonly text: string;
  readonly highlightedText?: string;
}

export function HighlightedText({ text, highlightedText }: HighlightedTextProps): JSX.Element {
  const parts: string[] = useMemo(
    () => (highlightedText ? text.split(new RegExp(`(${highlightedText})`, "gi")) : [text]),
    [highlightedText, text],
  );

  // oxlint-disable react/jsx-key
  return (
    <span>
      {parts.map((part) =>
        part.toLowerCase() === highlightedText?.toLowerCase() ? (
          <span className="bg-emphasis-secondary font-bold text-emphasis">{part}</span>
        ) : (
          <span>{part}</span>
        ),
      )}
    </span>
  );
}
